/* Browser (Web to poster) — the desktop's Browser ▸ Canva: pick a Canva account, browse its designs, print them,
 * save them to My library. Same Canva links as StudioCore (shared canva_accounts). */
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TopBar } from '../app/AppShell.jsx';
import { Card, EmptyState, Skeleton } from '../ui/index.jsx';
import { CanvaAccountPicker, CanvaDesigns, useCanvaAccounts } from '../features/browser/canva.jsx';
import { usePrintStore } from '../features/print/PrintStore.jsx';
import { useTranslation } from 'react-i18next';

const KEY = 'bv.canva.account';
const store = { get: () => { try { return localStorage.getItem(KEY); } catch { return null; } }, set: (v) => { try { localStorage.setItem(KEY, v); } catch { /* blocked */ } } };

export default function BrowserPage() {
  const { t } = useTranslation('bv');
  const { accounts, off, reload } = useCanvaAccounts();
  const [params, setParams] = useSearchParams();
  const { notify } = usePrintStore();
  const [openId, setOpenId] = useState(null);
  // Back from Canva sign-in: ?canva=linked&account=… or ?canva=error&reason=… (own callback), or
  // ?canva_linked=true&canva_account_id=…&auth_token=… (StudioCore's v10 callback, the interim bridge — the StudioCore
  // token is dropped unread: the URL is replaced right away).
  useEffect(() => {
    const c = params.get('canva') || (params.get('canva_linked') === 'true' ? 'linked' : null);
    if (!c) return;
    if (c === 'linked') { notify(t('canva.linkedToast'), 'green'); const id = params.get('account') || params.get('canva_account_id'); if (id) { store.set(id); setOpenId(id); } }
    else notify(t('canva.notFinished', { reason: params.get('reason') || t('canva.cancelledReason') }), 'coral', 7000);
    setParams({}, { replace: true });
    reload();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const account = accounts && openId ? accounts.find((a) => a.id === openId && a.signedIn) : null;
  return (
    <div className="bv-content" data-tour="browser-sites">
      <TopBar title={t('canva.title')} subtitle={t('canva.subtitle')} />
      {!accounts ? <Skeleton height={180} radius={24} />
        : off ? <Card><EmptyState icon="canva" title={t('canva.off.title')}>{t('canva.off.body')}</EmptyState></Card>
          : account ? <CanvaDesigns account={account} onSwitch={() => setOpenId(null)} onRelink={() => { setOpenId(null); reload(); notify(t('canva.relink'), 'yellow', 6000); }} />
            : (
              <div>
                <h2 className="bv-section-title" style={{ margin: '0 0 6px' }}>{t('canva.choose')}</h2>
                <p className="bv-muted" style={{ margin: '0 0 18px' }}>{t('canva.sameAsStudioCore')}</p>
                <CanvaAccountPicker accounts={accounts} onChanged={reload} onOpen={(a) => { store.set(a.id); setOpenId(a.id); }} />
              </div>
            )}
    </div>
  );
}
